export default __webpack_public_path__ + "static/media/RelocateIcon.5ff91215.svg";